//npm run build --configuration=staging
export const environment = Object.freeze({
  production: false,
  gateWayUrl: "https://gatewaystaging.devinfinitylearn.in",
  commServiceUrl: "https://comservice.devinfinitylearn.in",
  semServiceUrl:
    "https://3xnvbp3cbqxilxcynksgzltaru0vtmll.lambda-url.ap-south-1.on.aws",
  metaUrl:"https://testlms.ilteach.com",
  captchaSiteKey: "6LfSKrorAAAAALgCIJWzbndUFUSsQmv_A32b1j5w",
  ROLE_IDS: {
    EVALUATOR: 55,
  },
});
